import {
  Filter, CustomFilterType, FilterType, FilterCommonValues, PredefinedIds,
  PredefinedFilterType, PredefinedFilter
} from 'app/area/search-filters/filters/types';
import { allPredefinedFilters, filterId, fieldType } from 'app/area/search-filters/constants';
import { queryFilters } from 'app/area/import-mappings/search-filters/constants';
import { ImportMappingsTranslation } from 'app/area/import-mappings/constants';

export const codePredefinedFilters = (translation: ImportMappingsTranslation): PredefinedFilter => ({
  type: PredefinedFilterType.code,
  values: [
    { value: allPredefinedFilters.excludeInactiveCodes, description: translation.hide_inactive_codes_filter }
  ]
});

export const codeFilters = (importSet: number, translation: ImportMappingsTranslation): Filter[] => [
  {
    id: filterId.code,
    label: translation.code,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.inputIntegerWithoutExclude,
        includeInSummary: true
      }
    ],
    type: FilterType.TEXT_RANGE
  },
  {
    id: filterId.query,
    label: translation.description,
    fields: [
      {
        fieldTypeId: queryFilters.text,
        type: CustomFilterType.text,
        includeInSummary: true
      }
    ],
    type: FilterType.CUSTOM
  },
  {
    id: filterId.importSet,
    label: translation.import_mapping,
    fields: [
      {
        fieldTypeId: fieldType.externalValue,
        type: CustomFilterType.externalValueCheckbox,
        includeInSummary: false,
        options: [{
          value: 1,
          title: translation.match_exact
        }]
      },
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.externalValue,
        includeInSummary: true,
        hideDefaultFilterStyles: true,
        externalValueParams: {
          queryWithoutMatchExact: {
            importSet,
            valueOperator: { v: 16 }
          },
          queryWithMatchExact: {
            importSet,
            valueOperator: { v: 14 }
          }
        }
      }
    ].filter(field => !!field),
    type: FilterType.EXTERNAL_VALUE
  }
];

export const codeDefaultFilters = (
  translation: ImportMappingsTranslation
): { [key: string]: FilterCommonValues<number>[] } => ({
  [PredefinedIds.include]: [
    { value: allPredefinedFilters.excludeInactiveCodes, description: translation.hide_inactive_codes_filter }
  ]
});
